module.exports = __webpack_public_path__ + "img/screw-5.e195492d.png";